import { printSchemaWithDirectives, fixSchemaAst } from '@graphql-toolkit/common';
import { printWithComments, resetComments } from '@graphql-toolkit/schema-merging';
import { Kind, parse, Source as GraphQLSource } from 'graphql';
import { isEmptySDL, processImportSyntax, processImportSyntaxSync } from '../import-parser';
import { filterKind } from '../filter-document-kind';
export async function parseSource({ partialSource, options, globOptions, pointerOptionMap, addValidSource, cache, }) {
    if (partialSource) {
        const input = prepareInput({
            source: partialSource,
            options,
            globOptions,
            pointerOptionMap,
        });
        parseSchema(input);
        parseRawSDL(input);
        if (input.source.document) {
            useKindsFilter(input);
            useComments(input);
            await useGraphQLImport(input, () => processImportSyntax(input.source, input.options, cache));
            collectValidSources(input, addValidSource);
        }
    }
}
export function parseSourceSync({ partialSource, options, globOptions, pointerOptionMap, addValidSource, cache, }) {
    if (partialSource) {
        const input = prepareInput({
            source: partialSource,
            options,
            globOptions,
            pointerOptionMap,
        });
        parseSchema(input);
        parseRawSDL(input);
        if (input.source.document) {
            useKindsFilter(input);
            useComments(input);
            useGraphQLImport(input, () => processImportSyntaxSync(input.source, input.options, cache));
            collectValidSources(input, addValidSource);
        }
    }
}
//
function prepareInput({ source, options, globOptions, pointerOptionMap, }) {
    const specificOptions = {
        ...options,
        ...(source.location in pointerOptionMap ? globOptions : pointerOptionMap[source.location]),
    };
    return { source: { ...source }, options: specificOptions };
}
function parseSchema(input) {
    if (input.source.schema) {
        input.source.schema = fixSchemaAst(input.source.schema, input.options);
        input.source.rawSDL = printSchemaWithDirectives(input.source.schema, input.options);
    }
}
function parseRawSDL(input) {
    if (input.source.rawSDL) {
        input.source.document = isEmptySDL(input.source.rawSDL)
            ? {
                kind: Kind.DOCUMENT,
                definitions: [],
            }
            : parse(new GraphQLSource(input.source.rawSDL, input.source.location), input.options);
    }
}
function useKindsFilter(input) {
    if (input.options.filterKinds) {
        input.source.document = filterKind(input.source.document, input.options.filterKinds);
    }
}
function useComments(input) {
    if (!input.source.rawSDL) {
        input.source.rawSDL = printWithComments(input.source.document);
        resetComments();
    }
}
function useGraphQLImport(input, definitionsGetter) {
    if (input.options.forceGraphQLImport ||
        (!input.options.skipGraphQLImport && /^\#.*import /i.test(input.source.rawSDL.trimLeft()))) {
        function rewriteDoc(definitions) {
            input.source.document = {
                kind: Kind.DOCUMENT,
                definitions,
            };
        }
        const result = definitionsGetter();
        if (isPromise(result)) {
            return result.then(rewriteDoc);
        }
        rewriteDoc(result);
    }
}
function isPromise(val) {
    return val instanceof Promise;
}
function collectValidSources(input, addValidSource) {
    if (input.source.document.definitions && input.source.document.definitions.length > 0) {
        addValidSource(input.source);
    }
}
//# sourceMappingURL=parse.js.map